const UploadSvg = (props) => (
  <svg
    width={16}
    height={17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 1.41421L7.29289 0.707108L8 1.3323e-06L8.70711 0.707108L8 1.41421ZM9 10.4142C9 10.9665 8.55229 11.4142 8 11.4142C7.44772 11.4142 7 10.9665 7 10.4142L8 10.4142L9 10.4142ZM3 6.41422L2.29289 5.70711L7.29289 0.707108L8 1.41421L8.70711 2.12132L3.70711 7.12132L3 6.41422ZM8 1.41421L8.70711 0.707108L13.7071 5.70711L13 6.41421L12.2929 7.12132L7.29289 2.12132L8 1.41421ZM8 1.41421L9 1.41421L9 10.4142L8 10.4142L7 10.4142L7 1.41421L8 1.41421Z"
      fill="#219653"
    />
    <path
      d="M1 12.4142L1 13.4142C1 14.5188 1.89543 15.4142 3 15.4142L13 15.4142C14.1046 15.4142 15 14.5188 15 13.4142V12.4142"
      stroke="#219653"
      strokeWidth={2}
    />
  </svg>
);
export default UploadSvg;
